const urlDecode = (url) => {
  const newUrl = url.replace(/_/g, '/');
  return newUrl;
};

export default urlDecode;